import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-report-items',
  templateUrl: './add-report-items.component.html',
  styleUrls: ['./add-report-items.component.scss']
})
export class AddReportItemsComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<AddReportItemsComponent>) { }

  ngOnInit() {
  }

  onCloseClick(): void {
      this.dialogRef.close();
  }
}
